'use strict';

const slider = require('../components/slider');
const thumbnailSelection = require('../product/detail').thumbnailSelection;

var DIGIMAG_IFRAME_SELECTOR = "#mainFrame";
var hashObj = {"page":1};

var DIGIMAG_IFRAMEVIEWER_DEFAULTS = {
    domain: 'scholastic.caqgdigitalpublishing.com',
    urlAction: 'custom',
    disableRollovers : true,
    page: hashObj.page,
    numpages: 1,
    local: 1
};

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#quickViewModal').length !== 0) {
        $('#quickViewModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="quickViewModal" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <i class="fa-regular fa-xmark"></i>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * @typedef {Object} QuickViewHtml
 * @property {string} body - Main Quick View body
 * @property {string} footer - Quick View footer content
 */

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    const loader = $('#digimagModal .modal-content');
    loader.spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'HTML',
        success: function (data) {
            var parsedHtml = parseHtml(data);
            let $modalBody = $('#quickViewModal .modal-body');

            $modalBody.empty();
            $modalBody.html(parsedHtml.body);
            $('#quickViewModal .modal-footer').html(parsedHtml.footer);
            $('#quickViewModal .modal-header .close .sr-only').text(parsedHtml.body.data('closeButtonText'));
            $('#quickViewModal .enter-message').text(parsedHtml.body.data('enterDialogMessage'));
            $('#quickViewModal').modal('show');
            $('body').trigger('quickview:ready');

            // Apply slider to thumbnails in Quick view after loadig the images
            setTimeout (function () {
                slider();
            }, 500);
            
            loader.spinner().stop();
        },
        error: function () {
            loader.spinner().stop();
        }
    });
}

function handleIframeClick(data) {
    let iframe = $('#mainFrame')[0];
    var quickViewUrl = $(iframe).data('quickviewurl');
    quickViewUrl = quickViewUrl + '?pid=' + data.value.target;
    var redirectWindow = '';

    if (data.name === 'openUrl') {
        if(data.value.target && data.value.target.indexOf('-edu-ca') > -1){
            // for opening quick look of products
            getModalHtmlElement();
            fillModalElement(quickViewUrl);

            // To update the primary image on selection of thumbnail
            thumbnailSelection();
            
        }  else if (!!data.value.url) {
			// for opening all other links
			redirectWindow = window.open(data.value.url, '_blank');
			redirectWindow.location;
		} else if (!!quickViewUrl) {
            // for opening all other links
            redirectWindow = window.open(quickViewUrl, '_blank');
            redirectWindow.location;
        }
    }
}

function initializeIframeViewer(digimagFlyerId, digimagflyerName) {
    const iframe = $(DIGIMAG_IFRAME_SELECTOR);

    //-----CLEAR THE IFRAME HERE-----//
    iframe.attr('src', 'about:blank');

    setTimeout(() => {
        iframe.attr({
            'src': digimagFlyerId,
            'digimagflyerName': digimagflyerName
        });
        if (!digimagFlyerId) return;
        const options = $.extend({}, DIGIMAG_IFRAMEVIEWER_DEFAULTS, {
            issueId: digimagFlyerId
        });
        IframeViewer.start(iframe, options, function () {
            var digimagLoader = $( '#digimagModal .digimagLoader');

            if ($(digimagLoader).is(":visible")) {
                $(digimagLoader).hide();
            }
            IframeViewer.registerDataChangeCallback(handleIframeClick);
        });
    }, 100);
}

/**
 * @function
 * @description Opens Apple Status Modal on Order Confirmation page
*/
function openDigimagModal(digimagflyerId, digimagflyerName, isQuickLook) {
    if (isQuickLook) {
        $('.quickview-dialog .ui-dialog-titlebar-close').trigger('click');
    }
    $("#digimagModal").on('shown.bs.modal', function () {
        initializeIframeViewer(digimagflyerId, digimagflyerName);
    }).modal({keyboard: false, backdrop: 'static'});
}

module.exports = function () {
    $('body').on('click', '.open-digimag', function(e) {
        e.preventDefault();
        var isQuickLook = ($(this).closest("#QuickViewDialog").length > 0) ? true : false; 
        openDigimagModal($(this).data('digimagflyerid'), $(this).data('digimagflyername'), isQuickLook);
    });

    $('#reloadDigimag').on( 'click', function() {
        initializeIframeViewer($(DIGIMAG_IFRAME_SELECTOR).attr('src'), $(DIGIMAG_IFRAME_SELECTOR).attr('digimagflyerName'))
    });

    $('#digimagModal').on('hidden.bs.modal', function () {
        $('#digimagModal .digimagLoader').show();
    });

    window.addEventListener('message', function(event) {
        if (event.origin !== 'https://www.scholastic.ca') {
          return;
        }
        const data = event.data;
        handleIframeClick(data);
    });
};
